export const translate = {
    labels: {
        translate: "Translation",
        translations: "Translations",
        add_translate: "Add Translation",
        delete_translate: "Delete Translation",
    },
    placeholders: {
    },
    modals: {
        titles: {
        },
        messages: {
        },
    },
    texts: {
        empty: "There are no translations to display",
        add_translate: "Do you want to add a translation for this item?",
        delete_translate: "Do you want to delete this translation?<br/>This action cannot be undone.",
    },
};
